import cmaBackendQueryClient from "./clients/cmaBackend/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@uicomponents/ui/toaster";
import { TooltipProvider } from "@uicomponents/ui/tooltip";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { RouterProvider } from "@tanstack/react-router";
import router from "./router";
import { ModalProvider } from "@landingClient/components/ModalProvider";
import { PersistGate } from "redux-persist/integration/react";
import { PostHogProvider } from "posthog-js/react";
import { HelmetProvider } from "@dr.pogodin/react-helmet";

function Router() {
  return <RouterProvider router={router} />;
}

function App() {
  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={
        {
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
          defaults: "2025-11-30",
        } as const
      }
    >
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={<>Loading....</>} persistor={persistor}>
            <QueryClientProvider client={cmaBackendQueryClient}>
              <TooltipProvider>
                <Toaster />
                <ModalProvider />
                <Router />
              </TooltipProvider>
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </PostHogProvider>
  );
}

export default App;
